    export default{
        authurl:'https://laafi.in/auth/api/',
        consultationurl:'https://laafi.in/consults/api/',
        conferenceurl:'https://laafi.in/conferences/api/',
        hmsurl:'https://laafi.in/hms/api/',
        invoiceurl:'https://laafi.in/invoices/api/',
        pharmacyurl:'https://laafi.in/pharmacies/api/',
        schedulesurl:'https://laafi.in/scheduler/api/',
        labsurl:'https://laafi.in/labservices/api/',
        templatesurl:'https://laafi.in/templates/api/',
        bloodbankurl:'https://laafi.in/bloodbanks/api/'
    }
//   const localhost=`https://zoom.us/oauth/authorize?client_id=iM6Ze3l3R8SgerBDr1bDTg&response_type=code&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2Fdoctor%2Fdoctordashboard`

//  export default{
//         authurl:'https://laafiauthdev.azurewebsites.net/auth/api/',
//         consultationurl:'https://laaficonsultationdev.azurewebsites.net/api/',
//         conferenceurl:'https://laaficonferencedev.azurewebsites.net/api/',
//         hmsurl:'https://laafihms.azurewebsites.net/api/',
//         invoiceurl:'https://laafiinvoicesdev.azurewebsites.net/api/',
//         pharmacyurl:'https://laafipharmacy.azurewebsites.net/api/',
//         schedulesurl:'https://laafischedulesdev.azurewebsites.net/api/',
//         labsurl:'https://laafilabs.azurewebsites.net/api/',
//         templatesurl:'https://laafitemplatesdev.azurewebsites.net/api/',
//         bloodbankurl:'https://laafibloodbank.azurewebsites.net/api/'
//     }